(function($){
  var widowHeight = '';
  var topElement = '';
  
  $(document).ready(function(){
     if($('.card--default .card__info .card__title').length){
          $('.card--default .card__info .card__title').matchHeight();
     }

      if($(' .product__list:not(.card--expanded) .card--holder .card--default .card__title').length){
          $(' .product__list:not(.card--expanded) .card--holder .card--default .card__title').matchHeight();
      }

   

      var bstore = new BstrStore;
      if ($('[data-currency-selector]').length){
        $('.i18n__button label').attr('data-currency', $('[data-currency-selector]').val());
      }
      $('[data-currency-selector]').change(function(){
          $(this).closest('.i18n__button').find('label').attr('data-currency', bstore.get("currentCurrency"));
      })// Reinit swiper after fetch
      
      const originalFetch = window.fetch;
      var reInitSwiperCompleted = 0;
      window.fetch = function() {
          setTimeout(function(){
             if($('.card--default .card__info .card__title').length){
                $('.card--default .card__info .card__title').matchHeight();
             }
    
              if($(' .product__list:not(.card--expanded) .card--holder .card--default .card__title').length){
                  $(' .product__list:not(.card--expanded) .card--holder .card--default .card__title').matchHeight();
              }
              console.log('4544444')
          },1000); 
          return originalFetch.apply(this, arguments);
      };
  });
})( jQuery );